import * as React from "react";
import "twin.macro";

export default function WhyUs() {
  return (
    <section id="whyus" tw="container mx-auto py-24 px-6">
      <h2 tw="text-secondary text-4xl lg:text-5xl font-medium text-center leading-tight">
        <span tw="text-primary">Drei Gründe</span> warum Sie uns kontaktieren
        sollten <br />
      </h2>
      <div tw="lg:flex lg:mt-12 max-w-xs lg:max-w-none mx-auto">
        <div tw="lg:w-1/3 lg:pr-6">
          <span tw="text-8xl block max-w-xs text-right -mb-12 text-primary">
            01
          </span>
          <h4 tw="text-xl font-medium mt-4">Flexibel</h4>
          <p tw="max-w-xs mt-3">
            Wir erledigen eine große Bandbreite an Aufgaben. Sprechen Sie uns
            an. Mit uns haben Sie einen erfahrenen und zuverlässigen Partner
            damit ihr Garten gesund und schön bleibt.
          </p>
        </div>
        <div tw="lg:w-1/3 lg:px-6">
          <span tw="text-8xl block max-w-xs text-right -mb-12 text-primary">
            02
          </span>
          <h4 tw="text-xl font-medium mt-4">Ausdauernd</h4>
          <p tw="max-w-xs mt-3">
            Sehr gerne pflegen wir Ihren Garten das ganze Jahr. Egal ob
            Heckenschnitt, Düngen, oder Rasenpflege. Wir reduzieren Ihren
            eigenen Zeitaufwand für Ihre Gartenprojekte ganz nach Ihren
            Wünschen. Lassen Sie uns diese zeitraubenden Dinge erledigen.
          </p>
        </div>
        <div tw="lg:w-1/3 lg:pl-6">
          <span tw="text-8xl block max-w-xs text-right -mb-12 text-primary">
            03
          </span>
          <h4 tw="text-xl font-medium mt-4">Günstig</h4>
          <p tw="max-w-xs mt-3">
            Wir haben keine hohen Ausgaben und können somit einen fairen Preis
            für unsere Leistungen anbieten
          </p>
        </div>
      </div>
    </section>
  );
}
